export const createSimpleRange = (length) => {
    return Array.from(Array(length).keys());
};
//# sourceMappingURL=ranges.js.map